import { createSelector } from '@reduxjs/toolkit';
import { AsyncPatientAction } from './slice';
import { RootState } from 'store';
import { getClinics } from 'store/users/selectors';

export const selectPatients = (state: RootState) => state.patients.patients;
export const selectPatientListInfo = (state: RootState) => state.patients.patientListInfo;
export const selectCurrentPatientCase = (state: RootState) => state.patients.currentPatientCase;
export const selectPatientPageFilters = (state: RootState) => state.patients.patientPageFilters;
export const selectCurrentPatientCaseClinic = createSelector(
  [selectCurrentPatientCase, getClinics],
  (currentCase, clinics) => {
    const clinic = clinics.find((clinics) => clinics.id === currentCase?.clinicId);
    return clinic?.name ?? '';
  },
);
export const selectPatientCasesCount = (state: RootState) => state.patients.patientCasesCount;
export const selectPatientPageTimestamp = (state: RootState) => state.patients.patientsPageTimestamp;
export const selectPatientActionIsLoading = (asyncActionName: AsyncPatientAction) => (state: RootState) =>
  state.patients.asyncActionsAreLoading[asyncActionName];

export const selectActivityFeed = (state: RootState) => state.patients.activityFeed;
export const selectActivityFeedInfo = (state: RootState) => state.patients.activityFeedInfo;
export const selectActivityFeedFilter = (state: RootState) => state.patients.activityFeedFilter;

export const selectPatientMessages = (state: RootState) => state.patients.patientMessage;
export const selectPatientMessagesInfo = (state: RootState) => state.patients.patientMessageInfo;
export const selectPatientMessagesFilters = (state: RootState) => state.patients.patientMessageFilters;
export const selectPatientMessagesIsLoading = (state: RootState) =>
  state.patients.asyncActionsAreLoading.getPatientMessages;

export const selectCurrentPatientCaseIsLoading = (state: RootState) =>
  state.patients.asyncActionsAreLoading.getPatientCase;
export const selectActivityFeedIsLoading = (state: RootState) => state.patients.asyncActionsAreLoading.getActivityFeed;
export const selectGetPatientsIsLoading = (state: RootState) => state.patients.asyncActionsAreLoading.getPatientCases;

export const selectMessageAttachments = (state: RootState) => state.patients.messageAttachments;
export const selectMessageAttachmentsInfo = (state: RootState) => state.patients.messageAttachmentsInfo;
export const selectMessageAttachmentsReqParams = (state: RootState) => state.patients.messageAttachmentsRequestParams;
export const selectLastReadMessageId = (state: RootState) => state.patients.lastReadMessageId;
export const selectShouldMessagesPageUpdate = (state: RootState) => state.patients.shouldMessagesPageUpdate;
export const selectShouldPatientPageUpdate = (state: RootState) => state.patients.shouldPatientPageUpdate;
export const selectIsPatientPageEdited = (state: RootState) => state.patients.isPatientPageEdited;
